var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n        display: block;\n        margin: 0 auto;\n        '], ['\n        display: block;\n        margin: 0 auto;\n        ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/*
    06/14/2020 - Suhas

    This is a slider to show state in Rate-Quote slider.

    Following are the changes done from its original implementation:
    1. County is separated from the CountryState form
    2. City selection has also been removed
    
*/

import React, { useState, useEffect, useRef } from 'react';
import DotLoader from "react-spinners/DotLoader";
import { Row, Col, Form } from 'react-bootstrap';
import { css } from "@emotion/core";
import ThemeConfig from "../modules/ThemeConfig";
import { useSelector, useDispatch } from "react-redux";
import { countryStateUpdate, stateCountyUpdate, ShowButtons } from "../store/actions";
import axios from 'axios';

import { UserSession } from 'usersession';

var scrollToRef = function scrollToRef(ref) {
				return window.scrollTo(0, ref.current.offsetTop, { behavior: 'smooth' });
};
// General scroll to element function

export default function CountryState(props) {
				var userSession = new UserSession();

				var _useState = useState(false),
				    _useState2 = _slicedToArray(_useState, 2),
				    loading = _useState2[0],
				    setLoading = _useState2[1];

				var _useState3 = useState(null),
				    _useState4 = _slicedToArray(_useState3, 2),
				    error = _useState4[0],
				    setError = _useState4[1];

				var _useState5 = useState(""),
				    _useState6 = _slicedToArray(_useState5, 2),
				    propAddressState = _useState6[0],
				    setPropAddressState = _useState6[1];

				var _useState7 = useState(""),
				    _useState8 = _slicedToArray(_useState7, 2),
				    statesOptions = _useState8[0],
				    setStatesOptions = _useState8[1];

				var dispatch = useDispatch();
				var countryStateRedux = useSelector(function (state) {
								return state.nameReducer.countryState;
				});
				var stateCountyRedux = useSelector(function (state) {
								return state.nameReducer.stateCounty;
				});
				var stateListRedux = useSelector(function (state) {
								return state.nameReducer.stateList;
				});
				var myRefState = useRef(null);
				var themeConfig = new ThemeConfig(props);
				var domain = themeConfig.domain;

				useEffect(function () {
								//This function scroll the slider into view
								!localStorage.getItem('doNotScroll') && scrollToRef(myRefState);

								document.getElementById("next-button").disabled = false;
				}, []);

				var override = css(_templateObject);

				useEffect(function () {
								var zipCode = userSession.getPropertyZipCode();
								var propertyState = userSession.getPropertyState();
								var stateList = JSON.parse(userSession.getStateList());

								// every time you select a new state clear out county
								setPropAddressState(countryStateRedux);

								userSession.setPropertyState(countryStateRedux);

								if (propAddressState.length > 0) {
												dispatch(ShowButtons(true));
								}

								setStatesOptions(stateList.map(function (item, index) {
												return React.createElement(
																'option',
																{ key: index, value: item.code },
																item.name
												);
								}));

								if (zipCode.length < 5) {
												// if we already loaded property state then get it from the user session
												if (propertyState.length > 0) {
																setPropAddressState(propertyState);

																dispatch(countryStateUpdate(propertyState));
												}
												// else set it to the first item on the list
												else {
																				// setPropAddressState(response.data[0].code);
																				// userSession.setPropertyState(response.data[0].code);
																				// dispatch(countryStateUpdate(response.data[0].code));
																}
								}

								if (zipCode.length == 5) {
												setLoading(true);
												axios.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipCode, "", {
																headers: { 'Content-Type': 'application/json' }
												}).then(function (response) {
																setPropAddressState(response.data.state);

																userSession.setPropertyState(response.data.state);

																dispatch(countryStateUpdate(response.data.state));

																setLoading(false);
												}).catch(function (error) {
																setLoading(false);
																setError(error);
												});
								}

								// dispatch(ShowButtons(false));
				}, []);

				function clearStateCounty() {
								// every time you select a new state clear out county
								if (stateCountyRedux.length > 0) {
												dispatch(stateCountyUpdate(""));
												userSession.setPropertyCounty("");
								}
				}

				return React.createElement(
								React.Fragment,
								null,
								React.createElement(
												Row,
												{ className: 'd-flex justify-content-center pt-1' },
												React.createElement(
																Col,
																{ lg: 12 },
																React.createElement(
																				'h2',
																				null,
																				'Your State'
																)
												),
												loading ? React.createElement(
																Col,
																{ lg: 12 },
																React.createElement(
																				'div',
																				{ className: 'sweet-loading' },
																				React.createElement(DotLoader, {
																								css: override,
																								size: 20,
																								color: "#0069d9",
																								loading: loading
																				})
																)
												) : React.createElement(
																Form.Group,
																{ as: Col, lg: 4, md: 12 },
																React.createElement(
																				Form.Label,
																				{ className: 'sr-only' },
																				'State'
																),
																React.createElement(
																				Form.Control,
																				{ ref: myRefState, value: propAddressState, placeholder: 'Property State', onChange: function onChange(e) {
																												setPropAddressState(e.target.value);clearStateCounty();dispatch(countryStateUpdate(e.target.value));
																								}, as: 'select', custom: true },
																				statesOptions
																)
												)
								)
				);
}